// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1z-q";
export var animationRelative = "_1z-p";
export var backdropBlur = "_1z-0";
export var detailLabelCell = "_1z-12";
export var detailTable = "_1z-11";
export var detailValueCell = "_1z-13";
export var docIconBox = "_1z-1d";
export var docIconBoxMd = "_1z-1f";
export var docIconBoxSm = "_1z-1e";
export var docTypeRow = "_1z-16";
export var docTypeRowInner = "_1z-17";
export var dropdownMatchDatePicker = "_1z-3";
export var evidenceCardContent = "_1z-1c";
export var fileUploadSpin = "_1z-j";
export var gorgiasOpenButton = "_1z-15 _1z-d";
export var gorgiasTicketCard = "_1z-14";
export var heroModalFooterButton = "_1z-18";
export var hiddenContainer = "_1z-o";
export var iconPrimary = "_1z-1g";
export var iconSecondary = "_1z-1h";
export var iconTertiary = "_1z-1i";
export var integrationCard = "_1z-1";
export var integrationLogoBox = "_1z-2";
export var mainColumnSticky = "_1z-1b";
export var maxWidthContainer = "_1z-19";
export var modalContentBody = "_1z-a";
export var modalHeaderImage = "_1z-5";
export var modalImageLabel = "_1z-7";
export var modalImageOverlay = "_1z-6";
export var modalImageSubtitle = "_1z-9";
export var modalImageTitle = "_1z-8";
export var modalImageWrapper = "_1z-4";
export var modalStickyFooter = "_1z-b";
export var removeButton = "_1z-e";
export var sidebarColumn = "_1z-1a";
export var spinner = "_1z-i";
export var timelineLine = "_1z-y";
export var timelineLineBlack = "_1z-10 _1z-y";
export var timelineLineGray = "_1z-z _1z-y";
export var timelineLineHeight = "_1z-x";
export var tlDotActivate = "_1z-u";
export var tlDotActivateAnim = "_1z-t";
export var tlDotHide = "_1z-s";
export var tlDotHideAnim = "_1z-r";
export var tlLineActivate = "_1z-w";
export var tlLineActivateAnim = "_1z-v";
export var uploadHint = "_1z-n";
export var uploadIconBox = "_1z-k";
export var uploadLabel = "_1z-m";
export var uploadText = "_1z-l";
export var uploadZone = "_1z-f";
export var uploadZoneCursorDefault = "_1z-h";
export var uploadZoneCursorPointer = "_1z-g";
export var uploadedFileRow = "_1z-c";
export var viewButton = "_1z-d";